export type RequestFormState = {
  title: string;
  subtitle: string;
  description: string;
  authors: string[];
  editors: string[];
  isbn: string;
  issn: string;
  publisher: string;
  placeOfPublication: string;
  publicationYear: string;
  edition: string;
  format: string;
  quantity: string;
  estimatedCost: string;
  fundId: string;
  justification: string;
  urgency: string;
};

export const emptyRequestForm = (): RequestFormState => ({
  title: "",
  subtitle: "",
  description: "",
  authors: [],
  editors: [],
  isbn: "",
  issn: "",
  publisher: "",
  placeOfPublication: "",
  publicationYear: "",
  edition: "",
  format: "BOOK",
  quantity: "1",
  estimatedCost: "",
  fundId: "",
  justification: "",
  urgency: "MEDIUM",
});
